import AbstractDispatcher from 'frontools/abstract/AbstractDispatcher';
import GameAbstract from '../core/GameAbstract';
import Template from 'frontools/data/Template';
import { autobind } from 'frontools/decorators/Autobind';
import { Assets } from '../core/Assets';
import NumberUtils from 'frontools/utils/NumberUtils';
import { GameMode, GameManager } from '../core/GameManager';
import GameTimer from '../core/components/GameTimer';
import Context from 'frontools/core/Context';
import { Microbe } from './Microbe';

export class Attrapegrippette extends GameAbstract {

    public static instance                  : Attrapegrippette;
    
    private _levelWrapper                   : PIXI.Container                          = new PIXI.Container;
    private _microbesContainer              : PIXI.Container;

    private _background                     : PIXI.extras.AnimatedSprite;
    private _tree                           : PIXI.extras.AnimatedSprite;

    private _lumberjack                     : PIXI.extras.AnimatedSprite;
    private _lumberjackFace                 : PIXI.extras.AnimatedSprite;
    private _lumberjackContainer            : PIXI.Container;
    private _lumberArray                    : number[];
    private _lumberStatus                   : number;
    private _hitZone                        : PIXI.Graphics;

    private _timeScale                      : number            = 1;
    private _timeProgress                   : number            = 0;
    private _generatedTimeOut               : number;


    constructor() {
        super({
            time: 30,   
            countdown: 1,   
            results: [
                '0-44', //Bas      
                '45-84', //Moyen
                '85-9999' //Élevé  
            ],
            assets: [
                { name: 'background', url: 'sprite/background.png'},

                { name: 'tree', url: 'sprite/buche.png'},

                { name: 'lumberjack', url: 'sprite/lumberjack/lumber.json'},
                { name: 'face', url: 'sprite/lumberjack/face.json'},

                { name: 'microbe1', url: 'sprite/microbes/microbe1.json'},
                { name: 'microbe2', url: 'sprite/microbes/microbe2.json'},
                { name: 'microbe3', url: 'sprite/microbes/microbe3.json'},
                { name: 'microbe4', url: 'sprite/microbes/microbe4.json'},

                { name: 's_lumberjack1', url: 'audio/lumberjack/lumberjack1.mp3' },
                { name: 's_lumberjack2', url: 'audio/lumberjack/lumberjack2.mp3' },
                { name: 's_lumberjack3', url: 'audio/lumberjack/lumberjack3.mp3' },
                { name: 's_lumberjack4', url: 'audio/lumberjack/lumberjack4.mp3' },
                { name: 's_microbe1', url: 'audio/microbe/microbe1.mp3' },
                { name: 's_microbe2', url: 'audio/microbe/microbe2.mp3' },
                { name: 's_microbe3', url: 'audio/microbe/microbe3.mp3' },
                { name: 's_microbe4', url: 'audio/microbe/microbe4.mp3' },
                { name: 's_plop1', url: 'audio/plop/plop1.mp3' },
                { name: 's_plop2', url: 'audio/plop/plop2.mp3' },
                { name: 's_plop3', url: 'audio/plop/plop3.mp3' },
                { name: 's_plop4', url: 'audio/plop/plop4.mp3' }
            ]
            
        });

        // Pseudo singleton
        Attrapegrippette.instance = this;
    };


    /*
     * @core override
     * _onPreloadComplete - Called when the preload has been completed
     * 
     */
    protected _onPreloadComplete() {
        super._onPreloadComplete();

        this._microbesContainer = new PIXI.Container();  

        this._background = Assets.sprites['background'];
        this._tree = Assets.sprites['tree'];
        this._tree.pivot.x = this._tree.width / 2;
        this._tree.pivot.y = this._tree.height;

        this._lumberjack = Assets.sprites['lumberjack'];
        this._lumberjackFace = Assets.sprites['face'];
        this._lumberjackContainer = new PIXI.Container();
        this._lumberjackContainer.addChild(this._lumberjack);
        this._lumberjackContainer.addChild(this._lumberjackFace);

        this._lumberjackContainer.scale.x = 0.8;
        this._lumberjackContainer.scale.y = 0.8;
        this._lumberjackContainer.pivot.x = this._lumberjackContainer.width / 2;
        this._lumberjackContainer.pivot.y = this._lumberjackContainer.height / 2;

        this._lumberjack.pivot.x = this._lumberjack.width / 2;
        this._lumberjack.pivot.y = this._lumberjack.height / 2;
        this._lumberjack.x = (this._lumberjackContainer.width / 2) - 30;
        this._lumberjack.y = this._lumberjackContainer.height / 2;

        this._lumberjackFace.pivot.x = this._lumberjackFace.width / 2;
        this._lumberjackFace.pivot.y = this._lumberjackFace.height / 2;
        this._lumberjackFace.x = (this._lumberjackContainer.width / 2) + 5;
        this._lumberjackFace.y = 50;

        this._hitZone = this._drawRect((this._lumberjack.width - 150), (this._lumberjack.height - 150), 0x999999, 0);
        this._hitZone.pivot.x = this._hitZone.width / 2;
        this._hitZone.pivot.y = this._hitZone.height / 2;

        this._lumberStatus = 0;
        this._lumberArray = [0, 0, 0, 3, 3, 3, 6, 6, 6, 9, 9, 9];

        this._lumberjackContainer.addListener('click', function() { console.log("click lumber"); });
        
    };

    /*
     * @core override
     * _prepare - Prepare the game components and then starts the countdown
     * 
     */    
    protected _prepare() {        
        this._stage.addChild(this._background);
        this._stage.addChild(this._tree);
        this._stage.addChild(this._lumberjackContainer);
        this._stage.addChild(this._microbesContainer);   
        this._stage.addChild(this._hitZone);   
        
        // Trigger components positioning
        // Note: This will initialise core game components and start the countdown
        super._prepare(); 
    };
    
    private _generateMicrobes() {
        this._createNewMicrobe();
        this._gameTimer.addListener(GameTimer.TIME_CHANGE, function(e) {
            if (e.progress >= 0.93) clearTimeout(this._generatedTimeOut);       // Stop creating bads after a certain time
            this._timeProgress = e.progress;
        }.bind(this))
    }
    
    @autobind
    private _createNewMicrobe() {
        var microbe = new Microbe(NumberUtils.random(1, 4), this._context.isTouch());    
        Assets.sounds['s_microbe'+NumberUtils.random(1, 4)].play(); 
        microbe.addListener(Microbe.CLICK_MICROBE, this._onClickMicrobe);
        microbe.addListener(Microbe.HIT_LUMBER, this._onHitLumber);  
        this._microbesContainer.addChild(microbe.container);
          
        var timeout = 1350 * (1 - this._timeProgress);    // 1350 is the default delay when the game start
        if (timeout <= 600) timeout = 600;       // 800 is minimum delay between new bad creation
        this._generatedTimeOut = setTimeout(this._createNewMicrobe, timeout);
    }

    @autobind
    private _onClickMicrobe(e) {
        if (e.microbeNum === 1) { this._gameScore.add(2); }
        if (e.microbeNum === 2) { this._gameScore.add(3); }
        if (e.microbeNum === 3) { this._gameScore.add(4); }
        Assets.sounds['s_plop'+NumberUtils.random(1, 4)].play(); 
    }

    @autobind
    private _onHitLumber(e) {
        (e.microbeNum != 4) ? this._gameScore.remove(1) : this._gameScore.remove(5);
        Assets.sounds['s_lumberjack'+NumberUtils.random(1, 4)].play(); 

        this._lumberjackFace.play();
        this._lumberjackFace.onFrameChange = function(frame) {
            if (frame === this._lumberjackFace.totalFrames-1) this._lumberjackFace.gotoAndStop(0);
        }.bind(this);

        if (this._lumberStatus < this._lumberArray.length - 1) { this._lumberStatus ++; }
        this._lumberjack.gotoAndStop(this._lumberStatus);
        setTimeout(this._nextSlide, 150);        

        if (this._lumberArray[this._lumberStatus] === 6) {
            this._lumberjackFace.x = (this._lumberjackContainer.width / 2) - 11;
            this._lumberjackFace.y = 66;
            this._lumberjackFace.rotation = -20 * (Math.PI / 180);
            this._hitZone.y = this._lumberjackContainer.y + 20;
        } else if (this._lumberArray[this._lumberStatus] === 9) {
            this._lumberjackFace.x = (this._lumberjackContainer.width / 2) - 14;
            this._lumberjackFace.y = 81;
            this._hitZone.x = this._lumberjackContainer.x;
        } else {
            this._lumberjackFace.x = (this._lumberjackContainer.width / 2) + 5;
            this._lumberjackFace.y = 50;
            this._lumberjackFace.rotation = 0;
        }
    }

    @autobind
    private _nextSlide() {
        this._lumberjack.gotoAndStop(this._lumberArray[this._lumberStatus]);
    }

    private _drawRect(w: number = this._screenWidth, h: number = this._screenHeight, color: number = 0xFFFFFF, alpha: number = 1) {
        let rect = new PIXI.Graphics;
        rect.beginFill(color, alpha);
        rect.drawRect(0, 0, w, h);
        rect.endFill();
        return rect;
    };

    /*
     * @core override
     * _onTimerComplete - on game timer complete handler
     * @param {event} e - Event
     * 
     */
    protected _onTimerComplete(e) {
        super._onTimerComplete(e);

        clearTimeout(this._generatedTimeOut);
    };
    
    /*
     * @core override
     * _start - Starts the game
     *  
     */
    protected _start() {
        super._start();

        TweenMax.to(this, this._gameTimer.time, { _timeScale: 3, ease: Expo.easeOut });    //Higher the timeScale to reach is, the faster the enemies coming in will be
        
        this._generateMicrobes();
    };

    /*
     * @core override
     * _onTimerComplete - on game timer complete handler
     * @param {event} e - Event
     * 
     */


    protected _end() {
        super._end();
    }

    public get screenWidth() : number {
        return this._screenWidth;
    }

    public get screenHeight() : number {
        return this._screenHeight;
    }

    public get timeScale() : number {
        return this._timeScale;
    }

    public getLumberHitZoneX() {
        return {
            min: this._hitZone.x - (this._hitZone.width / 2),
            max: this._hitZone.x + (this._hitZone.width / 2),
        }
    }

    public getLumberHitZoneY() {
        return {
            min: this._hitZone.y - (this._hitZone.height / 2),
            max: this._hitZone.y + (this._hitZone.height / 2),
        }
    }

    /*
     * @core override
     * _resize - Resize handler
     * @param {event} e - Event
     * 
     */
    protected _resize(e?: Event) {
        super._resize(e);

        if (this._gameMode === GameMode.PLAYING || typeof e === 'undefined') {
            this._background.width = this._screenWidth; 
            this._background.height = this._screenHeight; 

            this._lumberjackContainer.x = this._screenWidth / 2;
            this._lumberjackContainer.y = (this._screenHeight / 2) + 50;
       
            this._hitZone.x = this._lumberjackContainer.x + 10;
            this._hitZone.y = this._lumberjackContainer.y + 10;            
            
            this._tree.x = (this._lumberjackContainer.x / 3) * 2;
            this._tree.y = this._lumberjackContainer.y + (this._lumberjackContainer.height / 2) - 30;
            this._tree.scale.x = 1.5;
            this._tree.scale.y = 1.5;
        }
    };

}